<template>
  <Layout :top-bar-title="title" :sections="sections" :baseLayoutInfoUrl="'/base-layout-info/'">
    <TopicForm
      :showHeader="false"
      @close="$router.push({name: 'TopicList'})"
      />
  </Layout>
</template>

<script>
import Layout from '@/apps/core/components/Layout'
import TopicForm from '../components/forms/TopicForm'
import sections from './defaultNavigationDrawerSections'
import { mapActions } from 'vuex'

export default {
  name: 'TopicDetail',
  components: { TopicForm, Layout },
  storeModule: 'budgetConcepts',
  data () {
    return {
      title: this.$t('topics.editTopic'),
      sections: sections,
      topicId: this.$route.params.id
    }
  },
  mounted () {
    this.getItem(this.topicId)
  },
  methods: {
    ...mapActions('budgetConcepts', ['getItem'])
  }
}
</script>
